import { render, staticRenderFns } from "./SubCompanyDropdown.vue?vue&type=template&id=16d85813"
import script from "./SubCompanyDropdown.vue?vue&type=script&lang=js"
export * from "./SubCompanyDropdown.vue?vue&type=script&lang=js"
import style0 from "./SubCompanyDropdown.vue?vue&type=style&index=0&id=16d85813&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports